import type { AllRouteEndpoints } from "../routeTypes";

// A test request saves nothing, so no cached queries go stale.
export const conversationalTestWebhookCacheKeys: AllRouteEndpoints[] = [];
